import { property as r } from "../beacon-property.d/index.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function a(t) {
  return r({ ...t, state: !0, attribute: !1 });
}
export {
  a as state
};
